import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";
import PercentField from './PercentField';

const ModalServiceFeeUpdate = ({ doCloseModalServiceFee, opened, service, profesional, updateFee }) => {
    const history = useHistory();

    const [typeFee, setTypeFee] = React.useState(1);
    const [valor, setValor] = React.useState(null);

    const [openModal, setOpenModal] = React.useState(opened);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {
        setTypeFee(service.tipo);
        setValor(service.valor);
    }, []);

    const addServiceFee = async () => {
        let dataServiceFee = {
            id_profesional:profesional.id_profesional,
            id_servicio:service.id_servicio,
            tipo:typeFee,
            valor:valor
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}honorarios/create`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataServiceFee)
        }).then(response => {
            if (response.status != 500 && response.status != 403)
            {
                updateFee(dataServiceFee.id_servicio,dataServiceFee.tipo,dataServiceFee.valor);
                closeModal();
            }
            else
            {
                throw new Error('Error en Grabar el Honorario');
            }
        }).catch(err => {
            alertModal(false,"Ha ocurrido un error en el sistema");
        });
    }

    const updateServiceFee = async () => {
        let dataServiceFee = {
            id_honorario:service.id_honorario,
            id_profesional:profesional.id_profesional,
            tipo:typeFee,
            valor:valor
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}honorarios/update`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataServiceFee)
        }).then(response => {
            if (response.status != 500 && response.status != 403)
            {
                if(service.id_servicio != null && service.id_servicio != undefined)
                {
                    updateFee(service.id_servicio,dataServiceFee.tipo,dataServiceFee.valor);
                    closeModal();
                }
                else
                {
                    window.location.reload();
                }
            }
            else
            {
                throw new Error('Error en Grabar el Honorario');
            }
        }).catch(err => {
            alertModal(false,"Ha ocurrido un error en el sistema");
        });
    }

    const closeModal = () => {
        doCloseModalServiceFee();
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Honorario</h5>
                        </div>
                        <Row>
                            <Col md={6}>
                                <TextField
                                    label="Nombre del Profesional"
                                    defaultValue={
                                        profesional.apellido2 != null ?
                                            profesional.nombres + ' ' + profesional.apellido1 + ' ' + profesional.apellido2 :
                                            profesional.nombres + ' ' + profesional.apellido1
                                    }
                                    disabled={true}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    label="Nombre del Servicio"
                                    value={service.nombre}
                                    disabled={true}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    select
                                    label="Tipo de Honorario"
                                    value={typeFee}
                                    onChange={(e) => setTypeFee(e.target.value)}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Porcentaje
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        Fijo
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={6}>
                                {
                                    typeFee == 1 ? <TextField
                                        label="Valor"
                                        value={valor}
                                        onChange={(event) => {
                                            setValor(event.target.value);
                                        }}
                                        className='medical-material-form__field'
                                        InputProps={{
                                            inputComponent: PercentField
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    />
                                        :
                                        <TextField
                                            label="Valor"
                                            value={valor}
                                            type="number"
                                            onChange={(e) => setValor(e.target.value)}
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                }
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                if (service.id_honorario != null && service.id_honorario != undefined) {
                                    updateServiceFee();
                                }
                                else //Guarda el Honorario para quedar independiente de la <Plantilla></Plantilla>
                                {
                                    addServiceFee();
                                }
                            }}
                        >
                            Guardar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalServiceFeeUpdate;
